<template>
  <b-card>
    <div style="position: relative">
      <loading-overlay :loading="loading" />
      <div class="d-flex justify-content-between">
        <h3>رسائل الجمهور</h3>
      </div>
      <hr />
      <div v-if="messages.length > 0">
        <ContactMessage
          v-for="item in messages"
          :key="item.id"
          :message="item"
        />
      </div>
      <alert massage="عذراً لا يوجد رسائل لعرضها" class="w-100" v-else></alert>
      <pagination
        v-if="!loading"
        v-model="currentPage"
        :currentPage.sync="currentPage"
        :total-rows="pagination.total_row"
        :per-page="pagination.per_page"
        align="center"
        class="mt-2"
      >
      </pagination>
    </div>
  </b-card>
</template>
<script>
import { BCard } from "bootstrap-vue";
import { mapGetters } from "vuex";
import Pagination from "@/components/pagination/index.vue";
import ContactMessage from "../../components/ContactMessage.vue";
import Alert from "@/components/Alert.vue";
import LoadingOverlay from "@/components/LoadingOverlay.vue";
export default {
  components: {
    BCard,
    Pagination,
    ContactMessage,
    Alert,
    LoadingOverlay,
  },
  data() {
    return {
      currentPage: 1,
    };
  },
  computed: {
    ...mapGetters("manageInterfaceNgo/GuestMessages", [
      "messages",
      "loading",
      "pagination",
    ]),
  },
  watch: {
    currentPage(value) {
      this.$store.dispatch("manageInterfaceNgo/GuestMessages/fetchMessages", {
        page: value,
      });
    },
  },
  created() {
    this.$store.dispatch("manageInterfaceNgo/GuestMessages/fetchMessages", {
      page: this.currentPage,
    });
  },
};
</script>
